import React, { useEffect, useRef } from "react"
import { makeStyles } from "@material-ui/core"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"

import TabPanel from "./tab-panel"

function a11yProps(index) {
  return {
    id: `result-tab-${index}`,
  }
}

const useStyles = makeStyles(theme => ({
  selectWrapper: {
    paddingTop: theme.spacing(4),
  },
  tabItem: {
    fontSize: "1.1rem",
  },
  outputTabSelect: {
    width: "100%",
  },
}))

export default function OutputTabSelect({
  tabs,
  children,
  autoScroll,
  selectedCriterion,
  setSelectedCriterion,
  ...others
}) {
  const classes = useStyles()
  const sectionRef = useRef(null)

  useEffect(function scrollIntoSection() {
    window.requestAnimationFrame(() => {
      if (autoScroll && sectionRef && sectionRef.current) {
        sectionRef.current.scrollIntoView({ behavior: "smooth" })
      }
    })
  }, [])
  return (
    <div {...others} ref={sectionRef} className={classes.selectWrapper}>
      <Select
        value={selectedCriterion}
        onChange={e => setSelectedCriterion(e.target.value)}
        aria-label="output data select"
        id="output-data-select"
        className={classes.outputTabSelect}
        variant="outlined"
      >
        {tabs.map((tab, index) => (
          <MenuItem
            value={index}
            {...a11yProps(index)}
            className={classes.tabItem}
            key={tab}
          >
            {tab}
          </MenuItem>
        ))}
      </Select>
      <TabPanel>{children}</TabPanel>
    </div>
  )
}
